export default {
  $schema: 'http://json-schema.org/draft-04/schema#',
  type: 'object',
  meta: {
    labelProperty: 'title',
  },
  properties: {
    key: {
      type: 'integer',
    },
    name: {
      type: 'string',
    },
  },
}
